(() => {
  const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  class Tooltip extends HTMLElement {
    constructor() {
      super();
      this.handleResize = debounce(this.updatePosition.bind(this), 250);
    }

    connectedCallback() {
      this.btn = this.querySelector(".tooltip");
      this.content = this.querySelector(".tooltip__content");
      this.container = this.dataset.container ? this.closest(this.dataset.container) : document.body;
      this.overlay = this.querySelector(".tooltip-overlay");

      if (!this.content || !this.btn || !this.overlay) {
        console.error("Tooltip: Required parent or content elements not found");
        return;
      }

      this.btn.addEventListener("click", () => {
        this.toggleTooltip();
      });

      this.overlay.addEventListener("click", () => {
        this.closeTooltip();
      });

      window.addEventListener("resize", this.handleResize);
      this.updatePosition();
    }

    disconnectedCallback() {
      window.removeEventListener("resize", this.handleResize);
    }

    toggleTooltip() {
      if (this.classList.contains("tooltip--open")) {
        this.closeTooltip();
      } else {
        this.openTooltip();
      }
    }

    openTooltip() {
      this.classList.add("tooltip--open");
    }

    closeTooltip() {
      this.classList.remove("tooltip--open");
    }

    updatePosition() {
      this.content.classList.remove("tooltip__content--bottom-right");
      this.content.classList.remove("tooltip__content--bottom-left");
      this.content.classList.remove("tooltip__content--bottom-center");

      this.content.classList.add("tooltip__content--normal");

      let parentRect = this.container.getBoundingClientRect();
      let contentRect = this.content.getBoundingClientRect();

      if (parentRect.left > contentRect.left || parentRect.right < contentRect.right) {
        this.content.classList.add("tooltip__content--bottom-center");
        this.content.classList.remove("tooltip__content--normal");
      }
      parentRect = this.container.getBoundingClientRect();
      contentRect = this.content.getBoundingClientRect();

      if (parentRect.left > contentRect.left) {
        this.content.classList.add("tooltip__content--bottom-left");
      } else if (parentRect.right < contentRect.right) {
        this.content.classList.add("tooltip__content--bottom-right");
      }
    }
  }

  if (!customElements.get("tool-tip")) {
    customElements.define("tool-tip", Tooltip);
  }
})();
